class ProductCardScroller {
  constructor(card) {
    this.card = card;
    this.container = card.querySelector('.media-arrow');
    if (!this.container) return;

    this.currentIndex = 0;
    this.didSwipe = false;
    this.swipeThreshold = 40;
    this.leftArrow = card.querySelector('.left-arrow');
    this.rightArrow = card.querySelector('.right-arrow');
    this.arrowBar = card.querySelector('.product_card-arrow');
    this.pagination = card.querySelector('.card-media-pagination');

    this.refreshImages();
    if (this.images.length === 0) return;

    this.container.classList.add('is-ready');
    this.showIndex(0);
    this.updateArrowVisibility();
    this.bindArrows();
    this.bindSwipe();
    this.bindPagination();
  }

  refreshImages() {
    this.images = Array.from(this.container.querySelectorAll(':scope > img.motion-reduce'));
  }

  get totalImageCount() {
    return this.images.length;
  }

  bindArrows() {
    if (this.leftArrow) {
      this.leftArrow.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prev();
      });
    }

    if (this.rightArrow) {
      this.rightArrow.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.next();
      });
    }
  }

  bindPagination() {
    if (!this.pagination) return;
    this.pagination.addEventListener('click', (e) => {
      const seg = e.target.closest('[data-index]');
      if (!seg) return;
      e.preventDefault();
      e.stopPropagation();
      const index = parseInt(seg.dataset.index, 10);
      if (!Number.isNaN(index)) this.showIndex(index);
    });
  }

  bindSwipe() {
    const target = this.card.querySelector('.card__inner') || this.card;
    const link = this.card.querySelector('.image-full_link');
    let startX = 0;
    let startY = 0;
    let tracking = false;
    let locking = null;

    const getPoint = (event) => {
      if (event.touches && event.touches[0]) return event.touches[0];
      if (event.changedTouches && event.changedTouches[0]) return event.changedTouches[0];
      return event;
    };

    target.addEventListener(
      'touchstart',
      (event) => {
        if (this.totalImageCount <= 1) return;
        const point = getPoint(event);
        startX = point.clientX;
        startY = point.clientY;
        tracking = true;
        locking = null;
        this.didSwipe = false;
      },
      { passive: true },
    );

    target.addEventListener(
      'touchmove',
      (event) => {
        if (!tracking) return;
        const point = getPoint(event);
        const dx = point.clientX - startX;
        const dy = point.clientY - startY;

        if (locking === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          locking = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }

        if (locking === 'x' && event.cancelable) {
          event.preventDefault();
        }
      },
      { passive: false },
    );

    target.addEventListener(
      'touchend',
      (event) => {
        if (!tracking) return;
        tracking = false;

        if (locking !== 'x') {
          locking = null;
          return;
        }

        const point = getPoint(event);
        const dx = point.clientX - startX;

        if (Math.abs(dx) >= this.swipeThreshold) {
          this.didSwipe = true;
          if (dx < 0) this.next();
          else this.prev();
        }

        locking = null;
      },
      { passive: true },
    );

    const suppressClick = (event) => {
      if (!this.didSwipe) return;
      event.preventDefault();
      event.stopPropagation();
      this.didSwipe = false;
    };

    this.card.addEventListener('click', suppressClick, true);
    if (link) link.addEventListener('click', suppressClick);
  }

  updatePagination() {
    if (!this.pagination) return;
    this.pagination.querySelectorAll('[data-index]').forEach((seg) => {
      const index = parseInt(seg.dataset.index, 10);
      seg.classList.toggle('is-active', index === this.currentIndex);
    });
  }

  updateArrowVisibility() {
    if (!this.arrowBar) return;
    const canScroll = this.totalImageCount > 1;
    this.arrowBar.hidden = !canScroll;
    this.arrowBar.classList.toggle('is-disabled', !canScroll);
  }

  showIndex(index) {
    if (!this.images.length) return;
    this.currentIndex = Math.max(0, Math.min(index, this.images.length - 1));
    this.images.forEach((img, i) => {
      img.classList.toggle('is-active', i === this.currentIndex);
    });
    this.updatePagination();
  }

  next() {
    if (this.currentIndex < this.images.length - 1) {
      this.showIndex(this.currentIndex + 1);
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.showIndex(this.currentIndex - 1);
    }
  }
}

function initProductCardScrollers(root = document) {
  root.querySelectorAll('.product-card-wrapper').forEach((card) => {
    if (card.dataset.cardScrollerInit === 'true') return;
    if (!card.querySelector('.media-arrow')) return;
    // Don't fight horizontal product-row carousels (featured collection, etc.)
    if (card.closest('.js-native-product-carousel, .product-carousel--native, .splide')) {
      return;
    }

    card.dataset.cardScrollerInit = 'true';
    new ProductCardScroller(card);
  });
}

window.initProductCardScrollers = initProductCardScrollers;

document.addEventListener('DOMContentLoaded', () => {
  initProductCardScrollers();
});

document.addEventListener('shopify:section:load', (event) => {
  initProductCardScrollers(event.target);
});
